import { set, update } from 'lodash/fp';
import * as actions from './actions';

export const reducer = {
  textract(state = { enabled: false }, action) {
    switch (action.type) {
      case actions.getDocumentExtractedTableData.success:
        return set('data', action.payload)(state);
      // DA-19204: field mapping is now managed by TanStack Query (domain/textract/queries)
      // and no longer stored in Redux
      case actions.toggle2WayMatchingForDocumentAction.type:
        return update('enabled', (value) => !value)(state);
      case actions.cleanDocumentExtractedTableData.type:
        // toggler state should remain when navigating through documents
        return { enabled: state.enabled };
      default:
        return state;
    }
  },
};
